import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ComponentRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    ViewContainerRef
} from '@angular/core';
import { animationFrameScheduler, fromEvent, Subscription } from 'rxjs';
import { auditTime, take } from 'rxjs/operators';
import { Dataset } from '../../../model/dataset/dataset';
import { DatapointsService } from '../../../data-access-layer/datapoints/datapoints.service';
import { DatasetFieldSpecificType } from '../../../model/dataset/dataset-field-specific.type';
import { MaptycsApplication } from '../../../model/account/maptycs-application';
import { SidePanelComponent } from '../../../core/side-panel/side-panel.component';
import { isEnabled } from '../../../../environments/environment';
import { Datapoint } from '../../../model/datapoint/datapoint';
import { DatasetField } from '../../../model/dataset/field/dataset-field';
import { Functionalities } from '../../../../environments/app-functionalities';
import { UserStateService } from '../../../auth/user-state-service';
import { DatapointsPageStateService } from '../datapoints-page-state.service';
import { TessadataDatasetStructure } from '../../../core/tessadata/tessadata-dataset-structure';
import { TessadataDataset } from '../../../core/tessadata/tessadata-dataset';
import { SidePanelService } from '../../../shared/services/side-panel.service';
import { DataPointsServiceState } from '../../../shared/services/datapoints-service-state';
import { SidePanels } from '../../../shared/services/side-panel.helper';
import { DownloadService } from '../../../data-access-layer/download/download.service';
import { AttachmentUtils } from '../../../core/utils/attachment-utils';
import { PoiClosestFilter } from 'src/app/model/datapoint/filter/poi-closest-filter';
import { NotifService } from '../../../core/notification/notif.service';
import { DownloadDatapointRequest } from '../../../model/download/download-datapoint-request';
import { COMMON_PANEL_WIDTH, Constants } from '../../../constants';
import { DownloadFileType } from '../../../model/download/download-file-type';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LocationProfile, PRECISELY_CRIME_BLOCK_GROUP_KEY, PRECISELY_CRIME_VINTAGE_KEY, dropdownMenuList } from 'src/app/model/datapoint/location-profile/location-profile';
import { DatapointsClimateChartService } from '../climate-charts/datapoints-climate-chart.service';
import { Climate } from 'src/app/core/utils/climate';
import { DatasetFieldType } from 'src/app/model/dataset/dataset-field-type';
import { DatePipe } from 'src/app/core/pipes/date.pipe';
import { DecimalPipe } from '@angular/common';
import { DatapointField } from 'src/app/model/datapoint/datapoint-field';
import { OpenWeather } from 'src/app/model/datapoint/open-weather';
import { DataService } from 'src/app/data.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { DialogModel } from 'src/app/model/dialog/dialog-model';

type UpdateDataPointComponentType = {
    dataset: Dataset;
}

@Component({
    selector: 'map-datapoints-profile-panel',
    templateUrl: './datapoints-profile-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./datapoints-profile-panel.component.scss']
})
export class DatapointsProfilePanelComponent implements OnInit, OnChanges, OnDestroy {
    // @Input() externalTensorFlightData: any;
    @Input() externalPOIDatasets: TessadataDataset[] = [];
    @Input() externalPOIDatasetsStructures: TessadataDatasetStructure[] = [];

    @Output() closed = new EventEmitter();
    @Output() datapointDeleted = new EventEmitter();
    @Output() updateSelectedDatapoint: EventEmitter<any> = new EventEmitter();
    @Output() onMoveModeEnabled: EventEmitter<Datapoint> = new EventEmitter();
    moveModeEnabled = false;

    updateDatapointPanel: ComponentRef<SidePanelComponent>;

    isExpanded = false;
    isOverlay = false;
    details: { datapointID: string, dataset: Dataset };
    fields = [];
    updating: boolean;
    datapoint: Datapoint;
    dataset: Dataset;
    datasetFields: { [key: string]: DatasetField; } = {}; // here we should have a map ID - field

    alterDatapointsEnabled = isEnabled(Functionalities.ALTER_DATAPOINTS);
    downloadDatapointsEnabled = isEnabled(Functionalities.DOWNLOAD_DATAPOINTS);

    hasWriteAccess = false;
    locationHasUploadedAttachments = false;
    poiClosestSubmittedFilter: PoiClosestFilter;

    // expand panel
    oldX = 0;
    grabber = false;
    subscription = new Subscription();
    private readonly PANEL_WIDTH = COMMON_PANEL_WIDTH;
    private readonly PANEL_MARGIN = 75;
    width: number;
    dragWidth: number;
    minWidthPx: number = Math.round(COMMON_PANEL_WIDTH * 0.5);
    maxWidthPx: number = window.innerWidth - this.PANEL_MARGIN;
    isAppliedWrap: boolean;
    isAccountAdmin: boolean;
    previousSelectedValue: any;

    @Input('mapDatapointInfo')
    set setMapDatapointInfo(details: { datapointID: string, dataset: Dataset }) {
        this.datapoint = null;
        this.details = details;
        if (!details) {

            return;
        }
        this.dataset = details.dataset;
        this.isOverlay = details.dataset.application === null;
        details.dataset.fields.forEach((field) => {
            this.datasetFields[field.id] = field;
        });
    }

    selectedGroup: UntypedFormGroup;
    selectedValue = new UntypedFormControl('INTERNAL');
    menuList: any;
    locationProfile = new LocationProfile();


    get DatasetFieldType() {
        return DatasetFieldType;
    }

    constructor(private readonly dpService: DatapointsService, private readonly changeDetector: ChangeDetectorRef,
        private readonly datapointsPageStateService: DatapointsPageStateService,
        private readonly userStateService: UserStateService,
        private readonly viewContainerRef: ViewContainerRef,
        private readonly sidePanelService: SidePanelService,
        private readonly datapointsServiceState: DataPointsServiceState,
        private readonly downloadService: DownloadService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly notifService: NotifService,
        private datapointsClimateChartService: DatapointsClimateChartService,
        private fb: UntypedFormBuilder,
        private maptycsDatePipe: DatePipe,
        private decimalPipe: DecimalPipe,
        private dataservice: DataService,
        private readonly route: ActivatedRoute,
        public readonly dialog: MatDialog
        ) {
    }

    ngOnInit() {
        this.selectedGroup = this.fb.group({
            defaultSelected: ['INTERNAL']
        });
        this.loadLocationProfileDropdown();
        this.hasWriteAccess = this.userStateService.hasWriteAccess(this.datapointsPageStateService.activeAccountId);
        const activeAccount = this.userStateService.principal.membership.find(params => params.accountID == this.datapointsPageStateService.activeAccountId);
        this.isAccountAdmin = activeAccount !== undefined && activeAccount.isAccountAdmin ? true : false;
        this.width = this.sidePanelService.getInitialPanelWidthPx(true, this.PANEL_WIDTH);
        this.dragWidth = this.width;
        this.minWidthPx = Math.round(this.PANEL_WIDTH * 0.5);
        this.maxWidthPx = Math.max(0, window.innerWidth - this.PANEL_MARGIN);
    }

    selectionChange($event) {
        this.selectedValue.setValue($event.value);
        this.updateSelectedDatapoint.emit({
            newSelectedValue: $event.value,
            prevSelectedValue: this.previousSelectedValue,
            blockGroupCode: this.getCrimeFieldValue(PRECISELY_CRIME_BLOCK_GROUP_KEY),
            blockGroupVintage: this.getCrimeFieldValue(PRECISELY_CRIME_VINTAGE_KEY),
            location: this.datapoint ? this.datapoint.location : null
        });
        if($event.value !== this.locationProfile.CLIMATE) {
            Climate.resetGraphTypes(this.datapointsClimateChartService);
        }
        this.applyChangeDetection();
        this.previousSelectedValue = $event.value;
    }

    /**
     * A Precisely Crime text field for this datapoint, used when drawing the Census block group
     * boundary. Null when the location has no crime data, which is the normal case outside the US.
     */
    private getCrimeFieldValue(fieldId: string): string {
        const field = this.datapoint?.fields?.find(item => item.id === fieldId);
        return field ? field.textValue : null;
    }

    onExpandedClick(expanded?: boolean) {
        this.isExpanded = (expanded !== undefined) ? expanded : !this.isExpanded;
        this.selectedGroup.controls.defaultSelected.reset();
        this.selectedGroup.controls.defaultSelected.setValue('INTERNAL');
        this.selectedValue = new UntypedFormControl('INTERNAL');
        if (!expanded) {
            this.closed.emit();
        }
        this.width = this.sidePanelService.getInitialPanelWidthPx(true, this.PANEL_WIDTH);
        this.dragWidth = this.width;
        this.isAppliedWrap = false;
        if (this.dataset?.id === OpenWeather.getId()) {
            // this.mapStateService.setRemoveOpenWeatherPolygon(true);
        }
    }

    ngOnChanges() {
        if (!this.details || !this.details.datapointID || !this.details.dataset) {
            return;
        }
        this.updating = false;
        this.fetchDatapoint();
        if (this.updateDatapointPanel) this.updateDatapointPanel.instance.hidePanel();
    }

    get DatasetFieldSpecificType() {
        return DatasetFieldSpecificType;
    }

    enableEditMode(): void {
        if (this.alterDatapointsEnabled) {
            this.sidePanelService.setRootViewContainerRef(this.viewContainerRef);
            if (this.updateDatapointPanel) {
                this.updateDatapointPanel.instance.hidePanel();
            }
            this.updating = true;
            this.updateDatapointPanel = this.sidePanelService.open<UpdateDataPointComponentType>(SidePanels.DATAPOINT_PROFILE,
                {
                    id: "update-datapoint-panel",
                    width: 500,
                    panelTitle: "Edit Datapoint",
                    panelIcon: "icon-pencil"
                },
                {
                    dataset: this.details.dataset
                });

            this.datapointsServiceState.onUpdateDataPointInit$.subscribe(() => {
                const {componentRef} = this.updateDatapointPanel.instance;
                if (componentRef) {
                    componentRef.instance.setDataset(this.details);
                }
            });
            this.datapointsServiceState.datapointUpdate$.subscribe((value) => {
                if (value === true) {
                    this.onUpdated();
                    this.updateDatapointPanel.instance.closePanel();
                } else {
                    this.notUpdated();
                }
            });
        }
    }

    onUpdated() {
        this.updating = false;
        this.changeDetector.detectChanges();
        this.fetchDatapoint();
        if (this.updateDatapointPanel) this.updateDatapointPanel.instance.hidePanel();
    }

    notUpdated() {
        this.updating = false;
        this.changeDetector.detectChanges();
        if (this.updateDatapointPanel) this.updateDatapointPanel.instance.hidePanel();
    }

    private fetchDatapoint() {
        this.dpService.getDatapoint(this.details.datapointID, this.details.dataset.id).subscribe((datapoint) => {
            datapoint.fields = this.getFilteredDatapointFields(datapoint.fields)
            this.datapoint = datapoint;
            this.fields = [];
            const ignoreFields = ['route_coordinates'];
            let idFieldValues = {};
            datapoint.fields.forEach((field) => {
                let value = field.textValue || field.numberValue || field.datetimeValue;
                if (value && !this.datasetFields[field.id].isGenerated && !ignoreFields.includes(field.id)) {
                    if (this.datasetFields[field.id].name !== 'id') {
                        let currentField = {
                            value,
                            name: this.datasetFields[field.id].displayName !== undefined && this.datasetFields[field.id].displayName !== null ? this.datasetFields[field.id].displayName : this.datasetFields[field.id].name,
                            type: this.datasetFields[field.id].type,
                            isSummary: this.datasetFields[field.id].isSummary
                        };
                        this.fields.push(currentField);
                    } else {
                        idFieldValues = {
                            value,
                            name: this.datasetFields[field.id].displayName !== undefined && this.datasetFields[field.id].displayName !== null ? this.datasetFields[field.id].displayName : this.datasetFields[field.id].name,
                            type: this.datasetFields[field.id].type,
                            isSummary: this.datasetFields[field.id].isSummary
                        };
                    }
                }
            });
            this.fields.push(idFieldValues);
            this.changeDetector.detectChanges();
        });
    }

    getFilteredDatapointFields(datapointFields): DatapointField[] {
        let fields: DatapointField[] = [];
        const datasetFieldIds = new Set(this.details.dataset.fields.map(field => field.id));

        if(datapointFields && datapointFields.length){
            datapointFields.forEach(element => {
                if(datasetFieldIds.has(element.id)){
                    fields.push(element)
                }
            });
        } else {
            fields = datapointFields;
        }

        return fields
    }

    ngOnDestroy() {
        if (this.updateDatapointPanel) {
            this.updateDatapointPanel.instance.closePanel();
            this.updateDatapointPanel = null;
        }
        this.subscription.unsubscribe();
    }

    downloadLocationProfile($event) {
        $event.preventDefault();
        this.downloadService.downloadLocationProfile(this.datapoint.id, this.dataset.id, this.poiClosestSubmittedFilter)
            .subscribe(response => AttachmentUtils.downloadFile(response),
                error => this.notifService.error('Something went wrong during download'));
    }

    downloadOverlayProfile($event) {
        $event.preventDefault();
        let fileName = 'overlay-profile.xlsx';
        let datapointIds = [];
        let geomFilter = null;
        this.dataservice.currentData.subscribe(data => geomFilter = data);
        datapointIds.push(this.datapoint.id);
        let request: DownloadDatapointRequest = {
            datapointRequest: {
                limit: 0,
                projection: {
                    datasetID: this.dataset.id,
                    geometryPrecision: 25,
                    fields: this.dataset.fields.map(f => f.id)
                },
                skip: 0,
                sort: null
            },
            filter: { datasetID: this.dataset.id, groups: [], geometryFilter: geomFilter },
            timezone: Constants.DEFAULT_TIMEZONE,
            dateFormat: Constants.DEFAULT_DATE_FORMAT,
            outputFileType: DownloadFileType.XLSX,
            datapointIds: datapointIds
        };
        this.downloadService.downloadDatapointsByIds(this.dataset.id, request, fileName).subscribe(
            response => {
                AttachmentUtils.downloadFileWithName(response, fileName);
            }, error => this.notifService.error('Something went wrong during download'));
    }

    // resize panel
    @HostListener('document:mouseup', ['$event'])
    onMouseUp(event: MouseEvent) {
        this.dragWidth = this.clampWidth(this.dragWidth);

        if (this.dragWidth) {
            this.sidePanelService.setSessionPanelWidthPx(this.dragWidth);
        }

        this.grabber = false;
        this.subscription.unsubscribe();
        if (this.dragWidth === this.width) {
            this.isAppliedWrap = false;
        }
    }

    resizer(offsetX: number) {
        const next = this.dragWidth - offsetX;
        this.dragWidth = this.clampWidth(next);
    }

    @HostListener('window:resize')
    onWindowResize() {
        this.maxWidthPx = Math.max(0, window.innerWidth - this.PANEL_MARGIN);
        this.dragWidth = this.clampWidth(this.dragWidth);
        this.applyChangeDetection();
    }

    private clampWidth(value: number): number {
        return Math.min(Math.max(value, this.minWidthPx), this.maxWidthPx);
    }

    onMouseDown(event: MouseEvent) {
        this.grabber = true;
        this.oldX = event.clientX;
        this.subscription.unsubscribe();
        const mousemoveGlobal = fromEvent<MouseEvent>(document, 'mousemove');
        this.subscription = mousemoveGlobal
            .pipe(auditTime(0, animationFrameScheduler))
            .subscribe((e) => this.onMouseMove(e));
    }

    onMouseMove(event: MouseEvent) {
        if (!this.grabber) {
            return;
        }
        this.resizer(event.clientX - this.oldX);
        this.oldX = event.clientX;
        this.applyChangeDetection();
        this.isAppliedWrap = true;

    }

    /**
     * Download Chart only applies to the two tabs that carry charts.
     *
     * The click has to check this as well as [disabled]: mat-menu-item on a div styles it as
     * disabled but a div has no native disabled behaviour, so the handler still fires - the menu
     * item looked greyed out and downloaded anyway.
     */
    get canDownloadChart(): boolean {
        return this.selectedValue.value === this.locationProfile.CLIMATE
            || this.selectedValue.value === this.locationProfile.CLIMATE_CHANGE;
    }

    downloadOverlayProfileChart() {
        const processedFields = this.processDatapointFields(this.datapoint.fields);
        Climate.downloadOverlayProfileChart(this.datapointsClimateChartService, this.notifService, 'locationProfileClimateChart', processedFields, null, this.selectedValue.value);
    }

    applyChangeDetection() {
        this.changeDetectorRef.detectChanges();
    }

    processDatapointFields(fields: any[]): any[] {
        const processedFields = [];

        for (const field of fields) {
            if (this.datasetFields[field.id].isSummary && field.isPresent) {
                const processedField = {
                    name: this.datasetFields[field.id].name,
                    value: ''
                };

                if (this.datasetFields[field.id].baseType === DatasetFieldType.DATE_TIME) {
                    processedField.value = this.maptycsDatePipe.transform(field.datetimeValue);
                } else if (this.datasetFields[field.id].baseType === DatasetFieldType.NUMBER) {
                    processedField.value = this.decimalPipe.transform(field.numberValue);
                } else if (this.datasetFields[field.id].baseType === DatasetFieldType.TEXT) {
                    processedField.value = field.textValue;
                }

                processedFields.push(processedField);
            }
        }

        // Adding latitude and longitude
        processedFields.push({
            name: 'Latitude',
            value: this.datapoint.location.y.toString()
        })
        processedFields.push({
            name: 'Longitude',
            value: this.datapoint.location.x.toString()
        })

        return processedFields;
    }

    deleteDatapoint() {
        const dialogRef = this.dialog.open(DialogComponent, {
                        data: new DialogModel(
                            "Confirm Action",
                            `Are you sure you want to delete the datapoint?`
                        ),
                    });
        dialogRef
                .afterClosed()
                .pipe(take(1))
                .subscribe((dialogResult) => {
                    if (dialogResult) {
                        this.dpService.deleteDatapoint(this.datapoint.datasetID, this.datapoint.id).subscribe((response) => {
                            if (response === null) {
                                this.notifService.success('Datapoint deleted successfully.')
                                this.onExpandedClick(false);
                                this.datapointDeleted.emit();
                                this.datapointsPageStateService.emitDatapointsChanged();
                            }
                        })
                    }
                });
    }

    getClass() {
        return this.dataset?.id === OpenWeather.getId() ? "open-weather-detail-row" : "detail-row";
    }

    /**
     * Loads the location profile dropdown data from the server and processes it.
     * This method is used both during initialization and when refreshing the dropdown.
     */
    private loadLocationProfileDropdown() {
        let accountId = this.route.snapshot.paramMap.get('accountId');
        let datasetId = this.route.snapshot.paramMap.get('datasetId');
        this.dpService.getLocationProfileDropdown(accountId, datasetId).subscribe((response) => {
            this.processDropdownResponse(response);
        });
    }

    /**
     * Processes the dropdown response and updates the menuList.
     * Sorts the entries with INTERNAL first, EXTERNAL second, then alphabetically.
     */
    private processDropdownResponse(response: any) {
        // CONSOLIDATED_RISK_SCORE lives on the Climate Change > Consolidated Risk Score tab, so it
        // has no dropdown view of its own.
        const entries = Object.entries(response)
            .filter(([key]) => key !== "CLIMATE_CHANGE_RISK_SCORE" && key !== "CONSOLIDATED_RISK_SCORE");
        const internal = entries.find(([key]) => key === "INTERNAL");
        const external = entries.find(([key]) => key === "EXTERNAL");
        const rest = entries.filter(([key]) => key !== "INTERNAL" && key !== "EXTERNAL");
        rest.sort((a, b) => (a[1] as string).localeCompare(b[1] as string));
        const finalSortedResponse: { [key: string]: string } = {};
        if (internal) finalSortedResponse[internal[0]] = internal[1] as string;
        if (external) finalSortedResponse[external[0]] = external[1] as string;
        for (const [key, value] of rest) {
            finalSortedResponse[key] = value as string;
        }
        this.menuList = Object.keys(finalSortedResponse).map((personNamedIndex) => {
            // Use dropdownMenuList enum value if available, otherwise use server value
            let displayLabel = finalSortedResponse[personNamedIndex];
            if (dropdownMenuList[personNamedIndex]) {
                displayLabel = dropdownMenuList[personNamedIndex];
            }
            let menu = [personNamedIndex, displayLabel];
            return menu;
        });
    }

    /**
     * Refreshes the location profile dropdown by calling getLocationProfileDropdown
     * and updating the menuList. This method can be called when workspace items are deleted
     * to ensure the dropdown reflects the current state.
     */
    refreshLocationProfileDropdown() {
        this.loadLocationProfileDropdown();
        // Trigger change detection to update the UI
        this.applyChangeDetection();
    }
}
